import './ErrorFallback.css';

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div className="error-fallback-overlay" role="alert" aria-live="assertive">
      <div className="error-fallback-card">

        <div className="error-code-badge">Runtime Error</div>

        <h1 className="error-fallback-heading">
          Something<br />went <span>wrong.</span>
        </h1>

        <p className="error-fallback-subtitle">
          An unexpected error interrupted this page.
          You can try again or return home.
        </p>

        <div className="error-message-block">
          <p className="error-message-label">Error details</p>
          <pre className="error-message-text">{error?.message ?? 'Unknown error'}</pre>
        </div>

        <div className="error-actions">
          <button className="error-btn-primary" onClick={resetErrorBoundary}>
            <svg className="btn-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M13.5 2.5A7 7 0 1 1 8 1M8 1l2.5 2.5L8 6" />
            </svg>
            Try again
          </button>

          <a className="error-btn-secondary" href="/">
            <svg className="btn-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M1 8h14M1 8l5-5M1 8l5 5" />
            </svg>
            Go home
          </a>
        </div>

      </div>
    </div>
  );
}

export default ErrorFallback;